<template>
  <div class="q-item">
    <p class="q-label">
      <span class="q-num">{{ qnum }}</span>
      {{ question }}
      <span v-if="required" class="q-required">*</span>
    </p>
    <div class="rating-group">
      <label
        v-for="opt in options"
        :key="opt"
        class="rating-opt"
        :class="{ selected: modelValue === opt }"
      >
        <input
          type="radio"
          :name="name"
          :value="opt"
          :checked="modelValue === opt"
          @change="$emit('update:modelValue', opt)"
        />
        <span class="icon-row">{{ emojis[opt] || '' }}</span>
        {{ opt }}
      </label>
    </div>
    <p v-if="error" class="error-msg">此欄位為必填</p>
  </div>
</template>

<script setup>
defineProps({
  qnum:       { type: String, required: true },
  question:   { type: String, required: true },
  name:       { type: String, required: true },
  options:    { type: Array,  required: true },
  required:   { type: Boolean, default: false },
  modelValue: { type: String, default: '' },
  error:      { type: Boolean, default: false },
})
defineEmits(['update:modelValue'])

const emojis = {
  '非常滿意': '😊', '滿意': '🙂', '普通': '😐', '不滿意': '😞',
  '一定會': '👍',  '可能會': '🤔', '不確定': '😶', '不會': '👎',
  '非常清楚': '😊', '清楚': '🙂', '不清楚': '😞',
  '非常符合': '😊', '符合': '🙂', '不符合': '😞',
}
</script>

<style scoped>
.q-item {
  padding: 1.1rem 1.25rem;
  border-bottom: 0.5px solid #f0f0f0;
}
.q-item:last-child { border-bottom: none; }

.q-label {
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
  margin: 0 0 0.65rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
}
.q-num      { color: #1a6aa8; font-weight: 500; }
.q-required { color: #c0392b; font-size: 11px; }

.rating-group {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
}
.rating-opt {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px 6px;
  border: 0.5px solid #ccc;
  border-radius: 8px;
  cursor: pointer;
  font-size: 12px;
  color: #666;
  text-align: center;
  min-height: 56px;
  line-height: 1.4;
  transition: border-color 0.15s, background 0.15s, color 0.15s;
  user-select: none;
}
.rating-opt input[type='radio'] { display: none; }
.rating-opt.selected {
  background: #e8f3fb;
  border-color: #1a6aa8;
  color: #0a3d62;
  font-weight: 500;
}
.rating-opt:hover {
  border-color: #1a6aa8;
  background: #f5f9fd;
}
.icon-row { font-size: 18px; }

.error-msg { font-size: 12px; color: #e74c3c; margin-top: 4px; }

@media (max-width: 480px) {
  .rating-group { grid-template-columns: repeat(2, 1fr); }
}
</style>